// SERVICES
import { getUsersBDDInfo } from './administration/usersService';
import { getTilesTypeLink, getTileProposals } from './tileService';
import { getAllNotifs } from './notificaitonService';
import { getEvents } from './eventService';
import { getUsersWhitelistAnnouncement } from './settingService';
import { getResources } from './resourceService';

export const searchInAdmin = async (searchTerm) => {
    if (!searchTerm.trim()) {
        return {
            users: [],
            tiles: [],
            tilesProposals: [],
            announcements: [],
            usersWhitelistAnnouncement: [],
            events: [],
            resources: []
        };
    }

    try {
        // Effectuer toutes les recherches en parallèle
        const [usersResponse, tilesResponse, tileProposalsResponse, announcementsResponse, usersWhitelistAnnouncementResponse, eventsResponse, resourcesResponse] = await Promise.all([
            getUsersBDDInfo(),
            getTilesTypeLink(),
            getTileProposals(),
            getAllNotifs(),
            getUsersWhitelistAnnouncement(),
            getEvents(),
            getResources()
        ]);

        const lowerSearchTerm = searchTerm.toLowerCase();

        // Filtrer les utilisateurs
        const users = usersResponse.data
            .filter(user => 
                user.USR_EMAILADDRESS.toLowerCase().includes(lowerSearchTerm)
            )
            .map(user => ({
                id: user.USR_ID,
                title: user.USR_EMAILADDRESS,
                path: '/admin/users/list'
            }));

        // Filtrer les tuiles
        const tiles = tilesResponse.data
            .filter(tile => 
                tile.titre.toLowerCase().includes(lowerSearchTerm) ||
                (tile.description && tile.description.toLowerCase().includes(lowerSearchTerm))
            )
            .map(tile => ({
                id: tile.id,
                title: tile.titre,
                path: '/admin/tiles/management'
            }));

        // Filtrer les propositions de tuiles
        const tilesProposals = tileProposalsResponse.data
            .filter(tileProposal => 
                (tileProposal.PRP_TITLE && tileProposal.PRP_TITLE.toLowerCase().includes(lowerSearchTerm)) ||
                (tileProposal.PRP_REASON && tileProposal.PRP_REASON.toLowerCase().includes(lowerSearchTerm)) ||
                (tileProposal.PRP_LINK && tileProposal.PRP_LINK.toLowerCase().includes(lowerSearchTerm)) ||
                (tileProposal.PRP_DESCRIPTION && tileProposal.PRP_DESCRIPTION.toLowerCase().includes(lowerSearchTerm)) ||
                (tileProposal.PRP_DECLINED_BY && tileProposal.PRP_DECLINED_BY.toLowerCase().includes(lowerSearchTerm)) ||
                (tileProposal.PRP_CREATED_BY && tileProposal.PRP_CREATED_BY.toLowerCase().includes(lowerSearchTerm)) ||
                (tileProposal.PRP_VALIDATED_BY && tileProposal.PRP_VALIDATED_BY.toLowerCase().includes(lowerSearchTerm))
            )
            .map(tileProposal => ({
                id: tileProposal.id,
                title: tileProposal.PRP_TITLE,
                path: '/admin/tiles/proposals'
            }));

        // Filtrer les annonces
        const announcements = announcementsResponse.data
            .filter(announcement => 
                announcement.NTF_CONTENT.toLowerCase().includes(lowerSearchTerm) ||
                (announcement.NTF_AUTHOR && announcement.NTF_AUTHOR.toLowerCase().includes(lowerSearchTerm))
            )
            .map(announcement => ({
                id: announcement.NTF_ID,
                title: announcement.NTF_CONTENT.substring(0, 50) + (announcement.NTF_CONTENT.length > 50 ? '...' : ''),
                path: '/admin/announcements/history'
            }));

        // Filtrer les utilisateurs whitelistés
        const usersWhitelistAnnouncement = usersWhitelistAnnouncementResponse.data
            .filter(user => 
                user.USERNAME.toLowerCase().includes(lowerSearchTerm)
            )
            .map(user => ({
                id: user.SIT_ID,
                title: user.USERNAME,
                path: '/admin/announcements/management'
            }));

        // Filtrer les événements
        const events = eventsResponse.data
            .filter(event => 
                event.title.toLowerCase().includes(lowerSearchTerm) ||
                (event.description && event.description.toLowerCase().includes(lowerSearchTerm))
            )
            .map(event => ({
                id: event.id,
                title: event.title,
                path: '/admin/events/management'
            }));

        // Filtrer les ressources
        const resources = resourcesResponse.data
            .filter(resource => 
                (resource.BCO_HEX && resource.BCO_HEX.toLowerCase().includes(lowerSearchTerm)) ||
                (resource.BCO_NAME && resource.BCO_NAME.toLowerCase().includes(lowerSearchTerm)) ||
                (resource.BTN_TITLE && resource.BTN_TITLE.toLowerCase().includes(lowerSearchTerm)) ||
                (resource.BTN_URL && resource.BTN_URL.toLowerCase().includes(lowerSearchTerm))
            )
            .map(resource => ({
                id: resource.BTN_ID,
                title: resource.BTN_TITLE,
                path: '/admin/resources/management'
            }));

        return {
            users,
            tiles,
            tilesProposals,
            announcements,
            usersWhitelistAnnouncement,
            events,
            resources
        };
    } catch (error) {
        console.error('Erreur lors de la recherche:', error);
        return {
            users: [],
            tiles: [],
            tilesProposals: [],
            announcements: [],
            usersWhitelistAnnouncement: [],
            events: [],
            resources: []
        };
    }
}; 